import React, { useState, useEffect, useContext, useCallback } from "react";
import { Modal, Button, Form, Row, Col, Card, Spinner } from "react-bootstrap";
import { FiSearch, FiEdit3, FiTrash2 } from "react-icons/fi";
import { toast } from "react-toastify";
import { Datacontext } from "../../context/Datacontext";
// import "./Magazine.css"
import * as pdfjsLib from "pdfjs-dist/webpack";



export function AdminMagazine() {
  const { magazines, setMagazines, refetch } = useContext(Datacontext); // refetch is key!
  const [filteredMagazines, setFilteredMagazines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [show, setShow] = useState(false);
  const [editing, setEditing] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [thumbnailMode, setThumbnailMode] = useState("auto"); 
// "auto" | "manual"


  const [form, setForm] = useState({
  title: "",
  description: "",
  coverImage: null,
  pdfFile: null,
  currentCoverImage: "",
  currentPdfFile: "",
  isPublished: true, // default: checked (visible to public)
});

  // Helper: Safe image & PDF URL
  const getFileUrl = (path) => {
    if (!path) return "";
    return path.startsWith("http") ? path : `${process.env.REACT_APP_BACKEND_URL}${path}`;
  };

  // Single source of truth: use global refetch from DataProvider
const loadMagazines = useCallback(async () => {
  setLoading(true);
  try {
    if (refetch) {
      await refetch();           // This updates global state
    } else {
      // Fallback (should never happen)
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/magazines`);
      const data = await res.json();
      const list = Array.isArray(data) ? data : data.data || [];
      setMagazines(list);
    }
  } catch (err) {
    toast.error("Failed to load magazines");
  } finally {
    setLoading(false);
  }
}, [refetch, setMagazines]);   // ← Correct dependencies

// FIXED: Only run once on mount!
useEffect(() => {
  loadMagazines();
}, []);   // ← EMPTY ARRAY! Only run once
 

  // Filter locally when search changes
  useEffect(() => {
    const term = searchTerm.toLowerCase();
    const filtered = magazines.filter(
      (mag) =>
        mag.title?.toLowerCase().includes(term) ||
        mag.description?.toLowerCase().includes(term)
    );
    setFilteredMagazines(filtered);
  }, [searchTerm, magazines]);

  const handleClose = () => {
    setShow(false);
    setEditing(null);
    setForm({
      title: "",
      description: "",
      coverImage: null,
      pdfFile: null,
      currentCoverImage: "",
      currentPdfFile: "",
      isPublished: true, // default: checked (visible to public)

    });
    // Clear file inputs
    const inputs = document.querySelectorAll('input[type="file"]');
    inputs.forEach(input => input.value = "");
  };

  const handleShow = () => setShow(true);
const generatePdfThumbnail = async (file) => {
  const buffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: buffer }).promise;
  const page = await pdf.getPage(1);

  // Desired thumbnail size
  const TARGET_WIDTH = 615;
  const TARGET_HEIGHT = 609;

  const viewport = page.getViewport({ scale: 1 });

  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  canvas.width = TARGET_WIDTH;
  canvas.height = TARGET_HEIGHT;

  const renderViewport = page.getViewport({
    scale: TARGET_WIDTH / viewport.width,
  });

  await page.render({
    canvasContext: context,
    viewport: renderViewport,
  }).promise;

  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), "image/jpeg", 0.85);
  });
};



//   const handleSubmit = async (e) => {
//     const token = localStorage.getItem("MagazineToken")

//     e.preventDefault();

//     if (!form.title || !form.description) {
//       toast.error("Title and Description are required");
//       return;
//     }

//     const data = new FormData();
//     data.append("title", form.title);
//     data.append("description", form.description);
//     data.append("isPublished", form.isPublished);
//     // PDF is always uploaded
// if (form.pdfFile) {
//   data.append("pdfFile", form.pdfFile);
// }

// // MANUAL thumbnail
// if (thumbnailMode === "manual" && form.coverImage) {
//   data.append("coverImage", form.coverImage);
// }

// // AUTO thumbnail (generated from PDF)
// if (thumbnailMode === "auto" && form.pdfFile) {
//   const thumbBlob = await generatePdfThumbnail(form.pdfFile);
//   data.append("coverImage", thumbBlob, "auto-thumbnail.jpg");
// }


//     const url = editing
//       ? `${process.env.REACT_APP_BACKEND_URL}/api/magazines/edit/${editing}`
//       : `${process.env.REACT_APP_BACKEND_URL}/api/magazines/add`;

//     try {
//       const res = await fetch(url, {
//         method: editing ? "PUT" : "POST",
//          headers: {
//         Authorization: `Bearer ${token}`,
//         // Do NOT set Content-Type → browser sets correct boundary
//       },
//         body: data,
//       });

//       if (!res.ok) {
//         const err = await res.text();
//         throw new Error(err || "Operation failed");
//       }

//       toast.success(editing ? "Magazine updated!" : "Magazine added!");
//       loadMagazines(); // This uses refetch → updates global state
//       handleClose();
//     } catch (err) {
//       toast.error("Error: " + err.message);
//     }
//   };
const handleSubmit = async (e) => {
  e.preventDefault();

  if (submitting) return; // prevent double click

  const token = localStorage.getItem("MagazineToken");

  if (!form.title || !form.description) {
    toast.error("Title and Description are required");
    return;
  }

  setSubmitting(true); // 🔥 START LOADING

  try {
    const data = new FormData();
    data.append("title", form.title);
    data.append("description", form.description);
    data.append("isPublished", form.isPublished);

    if (form.pdfFile) {
      data.append("pdfFile", form.pdfFile);
    }

    if (thumbnailMode === "manual" && form.coverImage) {
      data.append("coverImage", form.coverImage);
    }

    if (thumbnailMode === "auto" && form.pdfFile) {
      const thumbBlob = await generatePdfThumbnail(form.pdfFile);
      data.append("coverImage", thumbBlob, "auto-thumbnail.jpg");
    }

    const url = editing
      ? `${process.env.REACT_APP_BACKEND_URL}/api/magazines/edit/${editing}`
      : `${process.env.REACT_APP_BACKEND_URL}/api/magazines/add`;

    const res = await fetch(url, {
      method: editing ? "PUT" : "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });

    if (!res.ok) {
      const err = await res.text();
      throw new Error(err || "Operation failed");
    }

    toast.success(editing ? "Magazine updated!" : "Magazine added!");
    await loadMagazines();
    handleClose();
  } catch (err) {
    toast.error("Error: " + err.message);
  } finally {
    setSubmitting(false); // 🔥 STOP LOADING
  }
};
 
const editMagazine = (mag) => {
  setEditing(mag.id);
  setForm({
    title: mag.title || "",
    description: mag.description || "",
    coverImage: null,
    pdfFile: null,
    currentCoverImage: mag.cover_image || "",
    currentPdfFile: mag.pdf_file || "",
    isPublished: mag.is_published ?? true, // adjust field name based on your backend
  });
  setShow(true);
};

  const deleteMagazine = async (id) => {
        const token = localStorage.getItem("MagazineToken")


    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/magazines/delete/${id}`, {
        method: "DELETE",
          headers: {
        Authorization: `Bearer ${token}`,
        // Do NOT set Content-Type → browser sets correct boundary
      },
      });

      if (!res.ok) throw new Error("Delete failed");

      toast.success("Magazine deleted!");
      loadMagazines(); // Refetch globally
    } catch (err) {
      toast.error("Failed to delete");
    }
  };

  return (
    <div className="container py-2 admin-blogs-root">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold text-dark">Magazines</h2>

        {/* Floating Add Button */}
        <button
          onClick={handleShow}
          aria-label="Add new magazine"
          style={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            background: "linear-gradient(135deg,#6d28d9,#4c1d95)",
            color: "white",
            border: "none",
            fontSize: "32px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
            cursor: "pointer",
            zIndex: 999,
            transition: "0.3s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          +
        </button>
      </div>

      {/* Search */}
      <div className="input-group mb-4" style={{ maxWidth: "400px" }}>
        <span className="input-group-text bg-white border-end-0">
          <FiSearch className="text-muted" />
        </span>
        <input
          type="text"
          className="form-control border-start-0 ps-0"
          placeholder="Search title or description..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Content */}
      {loading ? (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "80vh" }}>
          <Spinner animation="border" variant="primary" style={{ width: "2rem", height: "2rem" }} />
          <h5 className="mt-4 text-muted">Loading magazines...</h5>
        </div>
      ) : filteredMagazines.length === 0 ? (
        <div className="text-center py-5">
          <h4 className="text-muted">
            {searchTerm ? "No matches found" : "No magazines yet"}
          </h4>
          {!searchTerm && <p className="text-muted">Click the + button to add one!</p>}
        </div>
      ) : (
        <Row>
          {filteredMagazines.map((mag) => (
<Col xl={3} sm={6} md={8} lg={4} className="mb-4" key={mag.id}>
<div className="card-wrapper">
  <Card 
    className="mag-card shadow-lg border-0 h-100 mb-10 overflow-hidden position-relative transition-all"
    style={{ 
      borderRadius: "18px",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      cursor: "pointer"
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-12px)";
      e.currentTarget.style.boxShadow = "0 20px 40px rgba(0,0,0,0.25)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.15)";
    }}
  >
    <div className="overflow-hidden" style={{ height: "210px" }}>
      <img
        src={getFileUrl(mag.cover_image)}
        alt={mag.title}
        className="w-100 h-100 transition-all"
        style={{ 
          objectFit: "cover",
          transition: "transform 0.5s ease"
        }}
        onError={(e) => { e.target.src = "/placeholder-magazine.jpg"; }}
       
      />
      {!mag.is_published && (
    <span className="blog-status-badge draft">
      Unpublished
    </span>)}
    </div>

    <Card.Body className="d-flex flex-column justify-content-between py-2">
      <div>
        <h5
          className="fw-bold text-dark mb-1 "
          style={{
            fontSize:"18px",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minHeight: "2em" // ensures same height even for short titles
          }}
        >
          {mag.title}
        </h5>
        <p 
          className="text-muted small mb-0"
          style={{
            fontWeight:"500",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minHeight: "2em" // consistent space for description
          }}
        >
          {mag.description}
        </p>
      </div>

      <div className="mt-4 mb-2 d-flex gap-3 justify-content-center">
        <Button
          onClick={() => editMagazine(mag)}
          className="d-flex align-items-center gap-2 shadow-sm"
          style={{
            background: "linear-gradient(135deg,#6d28d9,#4c1d95)",
            border: "none",
            borderRadius: "12px",
            padding: "9px 15px",
            transition: "all 0.3s ease"
          }}
        >
          <FiEdit3 size={18} /> Edit
        </Button>
        <Button
          variant="light"
          onClick={() => deleteMagazine(mag.id)}
          className="d-flex align-items-center gap-2 shadow-sm"
          style={{
            backgroundColor: "#fdf2f2",
            color: "#c92a2a",
            borderRadius: "12px",
            padding: "9px 15px",
            transition: "all 0.3s ease"
          }}
        >
          <FiTrash2 size={18} /> Delete
        </Button>
      </div>
    </Card.Body>
  </Card>
  </div>
</Col>
          ))}
        </Row>
      )}

      {/* Modal */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editing ? "Edit Magazine" : "Add New Magazine"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                required
                value={form.title}
                onChange={(e) => setForm({ ...form, title: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                required
                value={form.description}
                onChange={(e) => setForm({ ...form, description: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-3">
  <Form.Label className="fw-semibold">Cover Image</Form.Label>

  <div className="d-flex gap-4 mt-2">
    <Form.Check
      type="radio"
      label="Auto-generate from PDF (recommended)"
      name="thumbnailMode"
      value="auto"
      checked={thumbnailMode === "auto"}
      onChange={() => setThumbnailMode("auto")}
    />

    <Form.Check
      type="radio"
      label="Upload my own cover image"
      name="thumbnailMode"
      value="manual"
      checked={thumbnailMode === "manual"}
      onChange={() => setThumbnailMode("manual")}
    />
  </div>
</Form.Group>


            {thumbnailMode === "manual" && (
  <Form.Group className="mb-3">
    <Form.Label>Cover Image</Form.Label>
    <Form.Control
      type="file"
      accept="image/*"
      onChange={(e) =>
        setForm({ ...form, coverImage: e.target.files[0] || null })
      }
    />

    {form.currentCoverImage && !form.coverImage && (
      <small className="text-success">
        Current:{" "}
        <strong>{form.currentCoverImage.split("/").pop()}</strong>{" "}
        (<a
          href={getFileUrl(form.currentCoverImage)}
          target="_blank"
          rel="noreferrer"
        >
          View
        </a>)
      </small>
    )}
  </Form.Group>
)}


            <Form.Group className="mb-3">
              <Form.Label>Magazine PDF</Form.Label>
              <Form.Control
                type="file"
                accept="application/pdf"
                onChange={(e) => setForm({ ...form, pdfFile: e.target.files[0] || null })}
              />
              {form.currentPdfFile && !form.pdfFile && (
                <small className="text-success">
                  Current:<strong>{form.currentPdfFile.split("/").pop()}</strong>{" "}
                   (<a href={getFileUrl(form.currentPdfFile)} target="_blank" rel="noreferrer">View</a>)
                </small>
              )}
            </Form.Group>
            <Form.Group className="mb-3 d-flex align-items-center">
  <Form.Check
    type="checkbox"
    id="isPublished"
    label="Publish to main website (visible to all users)"
    checked={form.isPublished}
    onChange={(e) => setForm({ ...form, isPublished: e.target.checked })}
    className="me-2"
    style={{ fontSize: "1rem" }}
  />
</Form.Group>
{/* 
            <Button
              type="submit"
              className="w-100 mt-3"
              style={{ background: "linear-gradient(90deg,#6d28d9,#4c1d95)", border: "none" }}
            >
              {editing ? "Update" : "Add"} Magazine
            </Button> */}
            <Button
  type="submit"
  disabled={submitting}
  className="w-100 mt-3 d-flex align-items-center justify-content-center"
  style={{
    background: "linear-gradient(90deg,#6d28d9,#4c1d95)",
    border: "none",
    opacity: submitting ? 0.8 : 1,
  }}
>
  {submitting ? (
    <>
      <Spinner
        animation="border"
        size="sm"
        className="me-2"
        style={{ width: "1rem", height: "1rem" }}
      />
      {editing ? "Updating..." : "Adding..."}
    </>
  ) : (
    <>
      {editing ? "Update" : "Add"} Magazine
    </>
  )}
</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}